import { Contract } from './contract';
import { BankBilletData } from './bank-billet-data';
import { CreditCardData } from './credit-card-data';
import { PixData } from './pix-data';
import { Invoice } from './invoice';

export class CheckoutSuccessData {

  contract: Contract;
  bankBilletData: BankBilletData;
  creditCardData: CreditCardData;
  pixData: PixData;
  invoice: Invoice;

  redirectUrl: string;
  buttonCTA: string;
  baseURL: string;
  modalParams: object;
  modalType: string;
  pendingPaymentPurchase: boolean;
  changePaymentUrl: string;
  bonus: string;
  bonusAmount: number;
  order: any;
  oneClick: boolean;
  redirectConsentURL: string;
  purchaseOrigin: string;
  viewedRetentionModal: any;
  viewedCreditCardPaymentError: boolean;
  triggeredSecondaryCardAutoSelectFeature: boolean;

  constructor(contractData?: any) {
    if (contractData) {

      if (contractData.contract) {
        this.contract = new Contract(contractData.contract);
      } else if (contractData.order) {
        this.contract = new Contract(contractData.order);
      }

      if (contractData.bankBilletData) {
        this.bankBilletData = new BankBilletData(contractData.bankBilletData);
      }

      if (contractData.creditCardData) {
        this.creditCardData = new CreditCardData(contractData.creditCardData);
      }

      if (contractData.pixData) {
        this.pixData = new PixData(contractData.pixData);
      }

      if (contractData.invoice) {
        this.invoice = new Invoice(contractData.invoice);
      }

      this.redirectUrl = contractData.redirectUrl;
      this.buttonCTA = contractData.buttonCTA;
      this.baseURL = contractData.baseURL;
      this.modalParams = contractData.modalParams || {};
      this.modalType = contractData.modalType;
      this.bonus = contractData.bonus;
      this.bonusAmount = contractData.bonusAmount;
      this.order = contractData.order;
      this.oneClick = contractData.oneClick;
      this.purchaseOrigin = contractData.purchaseOrigin;
      this.redirectConsentURL = contractData?.redirectConsentURL;
      this.viewedCreditCardPaymentError = contractData?.viewedCreditCardPaymentError;
      this.triggeredSecondaryCardAutoSelectFeature = contractData?.triggeredSecondaryCardAutoSelectFeature;
      this.pendingPaymentPurchase = contractData.pendingPaymentPurchase;

      if (contractData.changePaymentUrl) {
        this.changePaymentUrl = contractData.changePaymentUrl;
      }

      if (contractData.viewedRetentionModal) {
        this.viewedRetentionModal = contractData.viewedRetentionModal;
      }
    }
  }

  getConcatenatedDiscounts(): string {
    if (this.contract.paymentMethod.identifier === 'CREDIT_CARD') {
      if (this.creditCardData && this.creditCardData.appliedCoupons && this.creditCardData.appliedCoupons.length) {
        return this.creditCardData.appliedCoupons.map(coupon => coupon.identifier).join('|');
      }
    } else if (this.contract.paymentMethod.identifier === 'BANK_BILLET') {
      if (this.bankBilletData.appliedCoupons && this.bankBilletData.appliedCoupons.length) {
        return this.bankBilletData.appliedCoupons.map(coupon => coupon.identifier).join('|');
      }
    } else if (this.contract.paymentMethod.identifier === 'PIX') {
      if (this.pixData.appliedCoupons && this.pixData.appliedCoupons.length) {
        return this.pixData.appliedCoupons.map(coupon => coupon.identifier).join('|');
      }
    }
    return null;
  }
}
